import gql from "graphql-tag";
import { gqlPaginatorInfo } from "../../../graphql/common.datatypes";
import { useQuery } from "react-apollo";
import { Note } from "../../../graphql/note.datatypes";

export interface NotesData {
    notes: {
        data: Note[];
        paginatorInfo: {
            count: number;
            currentPage: number;
            firstItem: number;
            hasMorePages: boolean;
            lastItem: number;
            lastPage: number;
            perPage: number;
            total: number;
        };
    };
}

export const GET_NOTES_QUERY = gql`
    query getNotes(
        $count: Int!,
        $page: Int!,
        $where: WhereConditions,
        $orderBy: [OrderByClause!]
    ) {
        notes(first: $count, page: $page, where: $where, orderBy: $orderBy) {
            data {
                id
                user_id
                group_id
                room_party_id
                billing_party_id
                group_member_id
                note
                created_at
                updated_at

                log {
                    id
                    user_id
                    code
                    type_id
                    user {
                        id
                        first_name
                        last_name
                    }
                }
            }
            ${gqlPaginatorInfo}
        }
    }
`;

export const getNotes = (
    count: number,
    page: number,
    where?: any,
    orderBy?: any
) =>
    useQuery<NotesData>(GET_NOTES_QUERY, {
        variables: {
            count,
            page,
            where,
            orderBy
        }
    });

export default getNotes;
